import {Radio, RadioProps} from "@mantine/core";

const useLegacy = false;

export default function SCRadioButton({ disabled, label, key, value }: any) {

    const mantineRadioInputProps: RadioProps = {
        disabled,
        label,
        key,
        value
    }

    //     // todo verify behaviour...
    //     // console.log(e.currentTarget)
    //     onChange && onChange({name: fieldName, value: e.currentTarget.checked, target: e.currentTarget})

    //     onChange && onChange({name: fieldName, value: e.value, target: e.target});
    // };

    return (
        !useLegacy
        &&
        <Radio mt={'0.5rem'}
               {...mantineRadioInputProps}
               color={'scBlue'}
        />
        ||
        <>
            <div className="input-container">
                <Radio
                    disabled={disabled}
                    label={label}
                    key={key}
                    value={value}
                />
            </div>
            <style jsx>{`

              .input-container {
                margin-top: 0.5rem;
              }

            `}</style>
        </>);
}
